export default __webpack_public_path__ + "static/media/strategic001.dde48e6e.png";